export const url = '/travel-file-notes';
export const Provider = 'TravelFileNotes';
export const tableName = 'travelfilenotes';
